import useAuth from './useAuth';

/**
 * Custom hook to check if division ID exists in assigned divisions
 * @param {string|number} divisionId - Division ID to check
 * @returns {boolean} - True if division exists, false otherwise
 */
export const useIsDivisionAssigned = (divisionId) => {
  const { assignedDivisions } = useAuth();
  console.log('Checking if division is assigned. Assigned Divisions: ', assignedDivisions, 'Division ID: ', divisionId);
  if (!assignedDivisions || !divisionId) {
    return false;
  }

  return assignedDivisions.some(
    (division) => division.id === divisionId || division === divisionId
  );
};
